import { formatMoneyKr } from '../../../utils';
import { fetchCollectedStatistics } from './organization-statistics-actions';
import moment from 'moment';
import OrganizationStatisticsChart from './OrganizationStatisticsChart';

const OrganizationCollected = ({ organizationId, from, to, setFrom, setTo }) => {
    return (
        <OrganizationStatisticsChart
            from={from}
            to={to}
            setFrom={setFrom}
            setTo={setTo}
            organizationId={organizationId}
            dataKey={'sum'}
            title={'Innsamlet over tid'}
            yAxisLabel={'Kroner'}
            tooltipFormatFunction={formatMoneyKr}
            fetchData={({ baseURL, organizationId, from, to }) =>
                fetchCollectedStatistics({
                    baseURL,
                    organizationId,
                    from: moment(from, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                    to: moment(to, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                })
            }
        />
    );
};

export default OrganizationCollected;
